import { ReactNode } from 'react';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';

import WanderingBoundary from 'features/wandering-boundary-settings/domain/models/wandering-boundary';
import WanderingBoundaryRowProviderContext from 'features/wandering-boundary-settings/providers/contexts/wandering-boundary-row-provider-context';
import useWanderingBoundaryRowProviderState from 'features/wandering-boundary-settings/providers/states/wandering-boundary-row-provider-state';

type Props = {
  children: ReactNode;
  wanderingBoundary: WanderingBoundary;
  viewingMode: ViewingMode;
};

const WanderingBoundaryRowProvider = ({ children, wanderingBoundary, viewingMode }: Props): React.JSX.Element => (
  <WanderingBoundaryRowProviderContext.Provider value={useWanderingBoundaryRowProviderState(wanderingBoundary, viewingMode)}>
    {children}
  </WanderingBoundaryRowProviderContext.Provider>
);

export default WanderingBoundaryRowProvider;
